<template>
	<tr class="hover:bg-gray-300 cursor-pointer" :class="{ 'bg-gray-400': !value.is_enabled }" @click="redirectToTarget">
		<td class="px-6 py-4 whitespace-no-wrap w-128">
			<div class="flex items-center">
				<div class="mr-4 w-8 flex justify-center">
					<font-awesome-icon :icon="['fas', getIcon]" size="2x" />
				</div>

				<div class="ml-4 text-left">
					<div class="text-md leading-5 font-medium text-gray-900 font-bold">{{ getName }}</div>
					<div class="text-md leading-5 text-gray-500">{{ getGroupName }}</div>
				</div>
			</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap" v-if="isRouteL5AndL6">
			<div class="text-md leading-5 text-gray-900">{{ getId }}</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap" v-if="!isInsurance">
			<div class="text-md leading-5 text-gray-900">{{ getDateString }}</div>
			<div class="text-md leading-5 text-gray-500">{{ getTimeString }}</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap" v-if="!isInsurance">
			<div class="text-md leading-5 text-gray-900">{{ getOwnerName }}</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap" v-if="!isInsurance">
			<div class="text-md leading-5 text-gray-900">{{ getAuthorLevel }}</div>
			<div class="text-md leading-5 text-gray-500">{{ getAuthorName }}</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap" v-if="isInsurance">
			<div class="text-md leading-5 text-gray-900">{{ getLocation }}</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap" v-if="isInsurance">
			<div class="text-md leading-5 text-gray-900">{{ getEmail }}</div>
		</td>

		<td class="px-6 py-4 whitespace-no-wrap text-right text-lg font-medium">
			<div class="flex space-x-4 items-center justify-end">
				<font-awesome-icon
					v-if="showEmployeesIcon"
					:icon="['fas', showEmployees ? 'users-slash' : 'users']"
					@click.stop="$router.push({ name: 'company_employees', params: { type: $route.params.type, id: value.company_id, backlink: $route.path } })"
					:title="showEmployees ? $t('hide_employee').toString() : $t('show_employee').toString()"
				/>

				<font-awesome-icon
					:icon="['fas', 'chart-bar']"
					class="cursor-pointer"
					:title="$t('statistics').toString()"
					v-if="$route.params.type === 'repairShop' || $route.params.type === 'car_dealership'"
					@click.stop="
						$router.push({ name: 'company_statistics', params: { type: $route.params.type, company_id: value.company_id, backlink: $route.path } })
					"
				/>

				<Toggle
					@click.stop="enableDisableCompany"
					:title="value.is_enabled ? this.$t('deactivate') : this.$t('activate')"
					v-if="showEnableDisableIcon && getUser.person.company.company_id !== value.company_id"
					:active="value.is_enabled"
				/>

				<font-awesome-icon :icon="['fas', 'chevron-right']" class="cursor-pointer" />
			</div>
		</td>
	</tr>
</template>
<script>
import { concatArray, getStringFromDate, getTimeFromDate } from '@/plugins/Utils';
import { DamageassessorscompanyApiFactory, InsurancesApiFactory, LawyerofficesApiFactory, RepairshopsApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Authentication from '@/mixins/Authentication';
import Toggle from '@/components/forms/Toggle';

export default {
	name: 'CompanyRow',
	components: { Toggle },
	mixins: [Authentication],
	props: {
		showEnableDisableIcon: { default: true },
		showEmployeesIcon: { default: true },
		value: {},
		isInsurance: { type: Boolean, default: false },
		companyType: {},
		showEmployees: null,
	},
	methods: {
		redirectToTarget() {
			if (this.$route.params.type === 'insurance') {
				this.$router.push({ name: 'insurancesprofile', params: { type: this.$route.params.type, id: this.value.id } });
			} else {
				this.$router.push({
					name: 'OtherCompanyProfile',
					params: { id: (this.value.company_id || this.value.id).toString(), backlink: this.$route.path },
				});
			}
		},
		enableDisableCompany() {
			const enabled = this.value.is_enabled;
			this.$swal({
				title: this.$t('sure').toString(),
				text: enabled ? this.$t('deactivate_entry').toString() : this.$t('activate_entry').toString(),
				icon: 'warning',
				cancelButtonText: this.$t('general.no').toString(),
				showCancelButton: true,
				confirmButtonText: this.$t('general.yes').toString(),
			}).then(result => {
				if (result.value) {
					this.value.is_enabled = !enabled;
					let promise;
					switch (this.$route.params.type) {
						case 'car_dealership':
						case 'repairShop':
							promise = RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).repairshopsIdPut(
								this.value.id,
								this.value,
							);
							break;
						case 'lawyerOffice':
							promise = LawyerofficesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).lawyerofficesIdPut(
								this.value.id,
								this.value,
							);
							break;
						case 'insuranceoffice':
						case 'insurance':
							promise = InsurancesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).insurancesIdPut(
								this.value.id,
								this.value,
							);
							break;
						case 'damageassessor':
							promise = DamageassessorscompanyApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).damageassessorscompanyIdPut(
								this.value.companyable.id,
								this.value,
							);
					}

					promise.then(() => {
						const prefix = this.companyType.buttonText + ' wurde ';
						this.$swal(this.$t('general.success').toString(), enabled ? prefix + 'deaktiviert' : prefix + 'wieder aktiviert', 'success');
					});
				}
			});
		},
	},
	computed: {
		isRouteL5AndL6() {
			return this.$route.params.type === 'repairShop' || this.$route.params.type === 'car_dealership';
		},
		getIcon() {
			switch (this.$route.params.type) {
				case 'damageassessor':
					return 'user-secret';
				case 'repairShop':
					return 'city';
				case 'car_dealership':
					return 'tools';
				case 'lawyerOffice':
					return 'gavel';
				case 'insurance':
					return 'shield-alt';
				case 'insuranceoffice':
					return 'briefcase';
				case 'agent_pool':
					return 'people-arrows';
			}
			return '';
		},
		getId() {
			return this.value.id;
		},
		getName() {
			return this.value.name ? this.value.name : this.value.ownerFirstname + ' ' + this.value.ownerLastname;
		},
		getLocation() {
			return this.value.city.zipCode + ' ' + this.value.city.name;
		},
		getEmail() {
			return this.value.email;
		},
		getGroupName() {
			return this.value?.usergroup?.name;
		},
		getAuthorName() {
			return concatArray([this.value.created_by?.person?.firstName, this.value.created_by?.person?.lastName]);
		},
		getAuthorLevel() {
			return this.value.created_by?.usergroup?.name;
		},
		getOwnerName() {
			return concatArray([this.value.ownerFirstname, this.value.ownerLastname]);
		},
		getDate() {
			return new Date(this.value.created_at * 1000);
		},
		getDateString() {
			return getStringFromDate(this.getDate);
		},
		getTimeString() {
			return getTimeFromDate(this.getDate);
		},
	},
};
</script>
